import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=75721f07&"
import script from "./TabItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./TabItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=75721f07&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports